const LANGUAGES = [
  { code: 'en', iso: 'en-US', native: 'English', english: 'English' },
  { code: 'hi', iso: 'hi-IN', native: 'हिन्दी', english: 'Hindi' },
  { code: 'kn', iso: 'kn-IN', native: 'ಕನ್ನಡ', english: 'Kannada' },
  { code: 'ta', iso: 'ta-IN', native: 'தமிழ்', english: 'Tamil' },
  {
    code: 'pt-PT',
    iso: 'pt-PT',
    native: 'Português',
    english: 'Portuguese',
    label: 'Português (Portugal)',
    searchAliases: ['European Portuguese', 'Portugal'],
  },
  {
    code: 'pt-BR',
    iso: 'pt-BR',
    native: 'Português',
    english: 'Portuguese',
    label: 'Português (Brasil)',
    searchAliases: ['Brazilian Portuguese', 'Brasil'],
  },
  { code: 'es', iso: 'es-ES', native: 'Español', english: 'Spanish' },
  { code: 'fr', iso: 'fr-FR', native: 'Français', english: 'French' },
  {
    code: 'zh-Hans',
    iso: 'zh-CN',
    native: '简体中文',
    english: 'Chinese',
    searchAliases: ['Simplified Chinese', 'Simplified'],
  },
  { code: 'ja', iso: 'ja-JP', native: '日本語', english: 'Japanese' },
  { code: 'fi', iso: 'fi-FI', native: 'Suomi', english: 'Finnish' },
  { code: 'sv', iso: 'sv-SE', native: 'Svenska', english: 'Swedish' },
  { code: 'de', iso: 'de-DE', native: 'Deutsch', english: 'German' },
  {
    code: 'fr-CA',
    iso: 'fr-CA',
    native: 'Français',
    english: 'French',
    searchAliases: ['Canadian French'],
  },
  { code: 'it', iso: 'it-IT', native: 'Italiano', english: 'Italian' },
  { code: 'cs', iso: 'cs-CZ', native: 'Čeština', english: 'Czech' },
  { code: 'nl', iso: 'nl-NL', native: 'Nederlands', english: 'Dutch' },
  { code: 'pl', iso: 'pl-PL', native: 'Polski', english: 'Polish' },
  { code: 'ru', iso: 'ru-RU', native: 'Русский', english: 'Russian' },
  { code: 'tr', iso: 'tr-TR', native: 'Türkçe', english: 'Turkish' },
  { code: 'ar', iso: 'ar-SA', native: 'العربية', english: 'Arabic' },
  { code: 'uk', iso: 'uk-UA', native: 'Українська', english: 'Ukrainian' },
  { code: 'no', iso: 'nb-NO', native: 'Norsk', english: 'Norwegian' },
  { code: 'da', iso: 'da-DK', native: 'Dansk', english: 'Danish' },
  { code: 'lt', iso: 'lt-LT', native: 'Lietuvių', english: 'Lithuanian' },
  { code: 'id', iso: 'id-ID', native: 'Bahasa Indonesia', english: 'Indonesian' },
  { code: 'he', iso: 'he-IL', native: 'עברית', english: 'Hebrew' },
  { code: 'sr', iso: 'sr-RS', native: 'Српски', english: 'Serbian' },
  { code: 'ro', iso: 'ro-RO', native: 'Română', english: 'Romanian' },
  {
    code: 'es-419',
    iso: 'es-419',
    native: 'Español',
    english: 'Spanish',
    searchAliases: ['Latin American Spanish'],
  },
  { code: 'mr', iso: 'mr-IN', native: 'मराठी', english: 'Marathi' },
  { code: 'af', iso: 'af-ZA', native: 'Afrikaans', english: 'Afrikaans' },
  { code: 'bn', iso: 'bn-BD', native: 'বাংলা', english: 'Bangla' },
  { code: 'ms', iso: 'ms-MY', native: 'Bahasa Melayu', english: 'Malay' },
  { code: 'ur', iso: 'ur-PK', native: 'اردو', english: 'Urdu' },
  { code: 'zu', iso: 'zu-ZA', native: 'IsiZulu', english: 'Zulu' },
  { code: 'te', iso: 'te-IN', native: 'తెలుగు', english: 'Telugu' },
  { code: 'ko', iso: 'ko-KR', native: '한국어', english: 'Korean' },
  { code: 'el', iso: 'el-GR', native: 'Ελληνικά', english: 'Greek' },
  { code: 'hu', iso: 'hu-HU', native: 'Magyar', english: 'Hungarian' },
  {
    code: 'zh-Hant',
    iso: 'zh-TW',
    native: '繁體中文',
    english: 'Chinese',
    searchAliases: ['Traditional Chinese', 'Traditional'],
  },
  { code: 'sq', iso: 'sq-AL', native: 'Shqip', english: 'Albanian' },
  { code: 'am', iso: 'am-ET', native: 'አማርኛ', english: 'Amharic' },
  { code: 'ceb', iso: 'ceb-PH', native: 'Cebuano', english: 'Bisaya' },
  { code: 'bg', iso: 'bg-BG', native: 'Български', english: 'Bulgarian' },
  { code: 'my', iso: 'my-MM', native: 'မြန်မာ', english: 'Burmese' },
  { code: 'yue', iso: 'yue-HK', native: '粵語', english: 'Cantonese' },
  { code: 'ca', iso: 'ca-ES', native: 'Català', english: 'Catalan' },
  { code: 'hr', iso: 'hr-HR', native: 'Hrvatski', english: 'Croatian' },
  { code: 'et', iso: 'et-EE', native: 'Eesti', english: 'Estonian' },
  { code: 'fa', iso: 'fa-IR', native: 'فارسی', english: 'Persian' },
  { code: 'fil', iso: 'fil-PH', native: 'Filipino', english: 'Filipino' },
  { code: 'nl-BE', iso: 'nl-BE', native: 'Vlaams', english: 'Flemish' },
  { code: 'gu', iso: 'gu-IN', native: 'ગુજરાતી', english: 'Gujarati' },
  { code: 'ht', iso: 'ht-HT', native: 'Kreyòl ayisyen', english: 'Haitian Creole' },
  { code: 'hmn', iso: 'hmn', native: 'Hmoob', english: 'Hmong' },
  { code: 'is', iso: 'is-IS', native: 'Íslenska', english: 'Icelandic' },
  { code: 'kar', iso: 'kar-MM', native: 'ကညီကျိာ်', english: 'Karen' },
  { code: 'km', iso: 'km-KH', native: 'ខ្មែរ', english: 'Khmer' },
  { code: 'lo', iso: 'lo-LA', native: 'ລາວ', english: 'Lao' },
  { code: 'lv', iso: 'lv-LV', native: 'Latviešu', english: 'Latvian' },
  { code: 'mk', iso: 'mk-MK', native: 'Македонски', english: 'Macedonian' },
  { code: 'ml', iso: 'ml-IN', native: 'മലയാളം', english: 'Malayalam' },
  { code: 'cmn', iso: 'cmn-CN', native: '中文', english: 'Mandarin' },
  { code: 'mh', iso: 'mh-MH', native: 'Kajin M̧ajeļ', english: 'Marshallese' },
  { code: 'ne', iso: 'ne-NP', native: 'नेपाली', english: 'Nepali' },
  { code: 'or', iso: 'or-IN', native: 'ଓଡ଼ିଆ', english: 'Odia' },
  { code: 'om', iso: 'om-ET', native: 'Oromoo', english: 'Oromo' },
  { code: 'ps', iso: 'ps-AF', native: 'پښتو', english: 'Pashto' },
  { code: 'pa', iso: 'pa-IN', native: 'ਪੰਜਾਬੀ', english: 'Punjabi' },
  { code: 'sn', iso: 'sn-ZW', native: 'ChiShona', english: 'Shona' },
  { code: 'si', iso: 'si-LK', native: 'සිංහල', english: 'Sinhala' },
  { code: 'sk', iso: 'sk-SK', native: 'Slovenčina', english: 'Slovak' },
  { code: 'sl', iso: 'sl-SI', native: 'Slovenščina', english: 'Slovenian' },
  {
    code: 'nso',
    iso: 'nso-ZA',
    native: 'Sesotho sa Leboa',
    english: 'Sepedi (North Sotho)',
    label: 'Sesotho sa Leboa (Sepedi / North Sotho)',
  },
  { code: 'sw', iso: 'sw-KE', native: 'Kiswahili', english: 'Swahili' },
  { code: 'tl', iso: 'tl-PH', native: 'Tagalog', english: 'Tagalog' },
  { code: 'th', iso: 'th-TH', native: 'ไทย', english: 'Thai' },
  { code: 'tpi', iso: 'tpi-PG', native: 'Tok Pisin', english: 'Tok Pisin' },
  { code: 'tn', iso: 'tn-ZA', native: 'Setswana', english: 'Tswana' },
  { code: 'vi', iso: 'vi-VN', native: 'Tiếng Việt', english: 'Vietnamese' },
  { code: 'xh', iso: 'xh-ZA', native: 'IsiXhosa', english: 'Xhosa' },
  { code: 'mi', iso: 'mi-NZ', native: 'Māori', english: 'Māori' },
  { code: 'sm', iso: 'sm-WS', native: 'Gagana Sāmoa', english: 'Samoan' },
  { code: 'to', iso: 'to-TO', native: 'Lea fakatonga', english: 'Tongan' },
]

const ALIASES = {
  'en-us': 'en',
  'en-gb': 'en',
  'pt': 'pt-PT',
  'pt-pt': 'pt-PT',
  'pt-br': 'pt-BR',
  'es-es': 'es',
  'es-la': 'es-419',
  'zh': 'zh-Hans',
  'zh-cn': 'zh-Hans',
  'zh-hans': 'zh-Hans',
  'zh-tw': 'zh-Hant',
  'zh-hant': 'zh-Hant',
  'el-gr': 'el',
  'de-de': 'de',
  'ja-jp': 'ja',
  'fr-fr': 'fr',
  'fr-ca': 'fr-CA',
  'it-it': 'it',
  'nb': 'no',
  'nb-no': 'no',
  'no-no': 'no',
  'in': 'id',
  'iw': 'he',
}

const BY_KEY = new Map()

for (const entry of LANGUAGES) {
  BY_KEY.set(entry.code.toLowerCase(), entry)
}

for (const [alias, code] of Object.entries(ALIASES)) {
  const entry = BY_KEY.get(code.toLowerCase())
  if (entry)
    BY_KEY.set(alias, entry)
}

export function resolveLanguage(code) {
  if (!code || typeof code !== 'string')
    return null
  return BY_KEY.get(code.trim().toLowerCase()) ?? null
}

export function getLanguageName(code) {
  const entry = resolveLanguage(code)
  if (!entry)
    return null
  if (entry.label)
    return entry.label
  return entry.native === entry.english
    ? entry.native
    : `${entry.native} (${entry.english})`
}

export function formatLanguageLabel(code, suffix) {
  const entry = resolveLanguage(code)
  if (!entry)
    return null
  const name = suffix ? `${getLanguageName(code)} ${suffix}` : getLanguageName(code)
  return `${name} | ${entry.iso}`
}

export function getLanguageIsoCode(code) {
  return resolveLanguage(code)?.iso ?? null
}

export function getLanguageSortName(code) {
  return resolveLanguage(code)?.english ?? null
}

export function getLanguageSearchTerms(code) {
  const entry = resolveLanguage(code)
  if (!entry)
    return []
  return [
    entry.code,
    entry.iso,
    entry.native,
    entry.english,
    ...(entry.searchAliases ?? []),
  ]
}

export function listLanguageCodes() {
  return LANGUAGES.map(entry => entry.code)
}

export { LANGUAGES }
